export const sliderProps = {
  classes: {
    default: {
      component: "container--content_vertical gap-[16px]",
      //[box-shadow:0px_0px_34px_0px_#0274E8]
      slideItem: "before:!content-none flex !px-0  [&_>_*]:border [&_>_*]:border-pacific-blue [&_>_*]:rounded-[10px] [&_>_*]:transition-all [&_>_*]:duration-500  [&_>_*:hover]:[box-shadow:0px_0px_10px_0px_#0274E8]",
      titleContainer: "flex-wrap mb-0 min-tablet:flex-nowrap [&_*]:font-[500] [&_*]:leading-[120%] [&_*]:text-[36px] [&_*]:text-white [&_*]:tracking-[.36px] [&_*]:min-tablet:leading-[55.2px] [&_*]:min-tablet:text-[46px] [&_*]:min-tablet:tracking-[0.46px] ",
      track: "gap-x-[clamp(33px,9vw,48px)] items-start overflow-visible [&:has(:hover)]:items-center"
    }
  },
  useFixedTrackHeight: true,
  showIndicatorButtons: false
}

export const sliderValues = {
  slideItemWidth: {
    desktop: 328,
    mobile: 230,
    tablet: 328,
  },
  trackColumnGap: {
    desktop: 48,
    mobile: 33,
    tablet: 48,
  }
}